import React, { useState, useEffect } from 'react';
import { makeStyles } from 'src/makeStyles';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles()(theme => ({
  scrollToTop: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 1000,
    bottom: 75,
    right: 28,
    overflowX: 'hidden',
    background: 'transparent',
    [theme.breakpoints.down(1024)]: {
      right: 15,
    },
    [theme.breakpoints.down(768)]: {
      display: 'none',
    },
  },
  scrollArrowContainer: {
    position: 'relative',
    background: colors.orange2,
    display: 'inline-block',
    borderRadius: '60px',
    padding: '5px',
    marginRight: '3px',
    width: '40px',
    height: '40px',
  },
  scrollArrowIcon: {
    color: colors.white,
    fontSize: fontSize.h6,
    position: 'absolute',
    top: '42%',
    left: '42%',
    transform: 'translate(-35%, -35%)',
  },
}));

const ScrollToTop = () => {
  const [scrolling, setScrolling] = useState(false);
  const [scrollInitialValue, setScrollInitialValue] = useState(0);
  const scrollShowValue = 1000;

  useEffect(() => {
    function onScroll() {
      const currentPosition = window.pageYOffset;
      const shouldScroll = currentPosition > scrollInitialValue;

      setScrolling(shouldScroll);
      setScrollInitialValue(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollInitialValue]);

  const { classes } = useStyles();
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      {scrollInitialValue > scrollShowValue && (
        <div className={classes.scrollToTop} onClick={scrollTop}>
          <div className={classes.scrollArrowContainer}>
            <ArrowUpwardOutlinedIcon className={classes.scrollArrowIcon} />
          </div>
        </div>
      )}
    </>
  );
};

export default ScrollToTop;
